// extracted by mini-css-extract-plugin
export default {"button":"Button_button__vh5FW","shimmer":"Button_shimmer__vXPXv","text":"Button_text__8-h3B","leftIcon":"Button_leftIcon__ha4sq","rightIcon":"Button_rightIcon__uErmW"};